const module = { name: 'shared/utils/a11y/tabbable', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



const Selectors = {
    UNTABBABLE: '[tabindex=-1]',
}


const Attributes = {
    TAB: 'tabindex',
}


const FOCUSABLE_ELEMENTS = [
    'a[href]',
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    'select:not([disabled]):not([aria-hidden])',
    'textarea:not([disabled]):not([aria-hidden])',
    'button:not([disabled]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"])'
].join(',')
function unblockChildren(parent, setFocus) {
    const $parent = $(parent);
    $parent
        .find(Selectors.UNTABBABLE)
        .each((index, element) => element.removeAttribute(Attributes.TAB));
    if (setFocus) {
        $parent
            .find(FOCUSABLE_ELEMENTS)
            .first()
            .focus();
    }
}
function blockChildren(parent) {
    $(parent)
        .find(FOCUSABLE_ELEMENTS)
        .each((index, element) => !element.getAttribute('data-block-opt-out') && element.setAttribute(Attributes.TAB, -1));
}
module.exports = {
    blockChildren,
    unblockChildren,
};
export default module.exports;